export const getFileNameFromBase64 = (base64String: string) => {
  const filenameMatch = base64String.match(/name=([^;]+)/);
  return filenameMatch ? filenameMatch[1] : null;
};
